import store from '@/store/index';
import { i18n } from '@/lang';
import {
    ROUTES_CHALLENGE,
    ROUTES_CHALLENGE_CREATE,
    ROUTES_CHALLENGE_TEAM_FORM,
    ROUTES_CHALLENGES
} from '@/constants/routes';

export default {
    path: '/challenges',
    name: 'challenges-main',
    component: () => import(/*webpackChunkName: 'challenges'*/ '@/views/Challenges.vue'),
    children: [
        {
            path: '/challenges',
            name: ROUTES_CHALLENGES,
            component: () =>
                import(/*webpackChunkName: 'challenges'*/ '@/components/challenges/secured/challenges/Challenges.vue')
        },
        {
            path: '/challenges/create/:challengeSlug?',
            name: ROUTES_CHALLENGE_CREATE,
            beforeEnter: guardRouteChallengeForm,
            component: () =>
                import(
                    /*webpackChunkName: 'challenges'*/ '@/components/challenges/secured/create-challenge/CreateChallenge.vue'
                )
        },
        {
            path: '/challenges/:challengeSlug',
            name: ROUTES_CHALLENGE,
            component: () =>
                import(/*webpackChunkName: 'challenges'*/ '@/components/challenges/secured/overview/ChallengeMain.vue')
        },
        {
            path: '/challenges/:challengeSlug/add-challenge-team/:teamId?',
            name: ROUTES_CHALLENGE_TEAM_FORM,
            beforeEnter: guardRouteChallengeTeamForm,
            component: () =>
                import(
                    /*webpackChunkName: 'challenges'*/ '@/components/challenges/secured/create-challenge-team/ChallengeTeamForm.vue'
                )
        }
    ]
};

function guardRouteChallengeTeamForm(to, from, next) {
    if (!store.getters['userPermissions/manageChallengeTeams']) {
        store.dispatch('notifyError', { message: i18n.t('notAuthorizedToSeeThisPage') });
        next({ name: ROUTES_CHALLENGES });
    } else {
        next();
    }
}

function guardRouteChallengeForm(to, from, next) {
    if (!store.getters['userPermissions/manageChallenges']) {
        store.dispatch('notifyError', { message: i18n.t('notAuthorizedToSeeThisPage') });
        next({ name: ROUTES_CHALLENGES });
    } else {
        next();
    }
}
